import CssBaseline from '@material-ui/core/CssBaseline';
import Drawer from '@material-ui/core/Drawer';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import clsx from 'clsx';
import React from 'react';
import { UseStore } from 'zustand';

type SideDrawerProps = {
  toggle: UseStore<{ open: boolean }>;
  anchor?: 'left' | 'right';
  sideContent?: React.ReactNode;
  children?: React.ReactNode;
  width?: number;
  variant?: 'permanent' | 'persistent' | 'temporary';
  onClose?: () => void;
}

//This CSS is necessary to shrink the content pain, if that feature is desirable
/*
      flexGrow: 1,
      padding: theme.spacing(0),
      transition: theme.transitions.create('margin', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      marginRight: -drawerWidth,
      */

const rightStyles = (drawerWidth: number) => makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
    },
    appBar: {
      transition: theme.transitions.create(['margin', 'width'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
    },
    appBarShift: {
      width: `calc(100% - ${drawerWidth}px)`,
      transition: theme.transitions.create(['margin', 'width'], {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
      marginRight: drawerWidth,
    },
    title: {
      flexGrow: 1,
    },
    hide: {
      display: 'none',
    },
    drawer: {
      width: drawerWidth,
      flexShrink: 0,
    },
    drawerPaper: {
      width: drawerWidth,
    },
    drawerHeader: {
      display: 'flex',
      alignItems: 'center',
      padding: theme.spacing(0, 0),
      // necessary for content to be below app bar
      ...theme.mixins.toolbar,
      justifyContent: 'flex-start',
    },
    content: {

    },
    contentShift: {
      transition: theme.transitions.create('margin', {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
      marginRight: 0,
    },
  }),
);

const leftStyles = (drawerWidth: number) => makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  appBar: {
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: drawerWidth,
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  hide: {
    display: 'none',
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
  },
  drawerPaper: {
    width: drawerWidth,
  },
  drawerHeader: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
    justifyContent: 'flex-end',
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    overflow: 'hidden',
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: -drawerWidth,
  },
  contentShift: {
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: 0,
  },
}));


//TODO fix left variant
export function SideDrawer(props: SideDrawerProps) {
  const { anchor, width, variant, sideContent, children, toggle} = { ...{ width: 550, anchor: 'right', variant: 'temporary' }, ...props };

  const classes = anchor === 'left' ? leftStyles(width)() : rightStyles(width)();
  
  const open = toggle(s => s.open);

  const onClose = () => {
    toggle.setState({ open: !toggle.getState().open })
  }
  return (
    <div className={classes.root}>
      <CssBaseline />
      <main className={clsx(classes.content, { [classes.contentShift]: open })}>
        {
          <div style={{ width: '100%', height: '100%' }}>
            {children as any}
          </div>
        }
      </main>

      <Drawer
        className={classes.drawer}
        classes={{ paper: classes.drawerPaper }}
        anchor={anchor as any}
        variant={variant as any}
        open={open}
        onClose={onClose} >
        <div style={{
          marginTop: 6,
          paddingLeft: 12,
          paddingRight: 12,
          width: '100%',
          height: '100vh',
          backgroundColor: '#fff',
          overflowX: 'hidden',
          overflowY: 'scroll'
        }}>
          {sideContent as any}
        </div>
      </Drawer>


    </div>
  );
}
